import BooleanConfiguration from 'Pages/GMS/ISR/Components/BooleanConfiguration';
import FieldComponent from 'Pages/GMS/ISR/Components/FieldComponent';
import RulesComponent from 'Pages/GMS/ISR/Components/Rules/RulesComponent';
import React from 'react';
import { TConnector, TField, TFieldDataConfiguration, TIndexState, TProductCategory, TSubmodel, TUpsertISRProjectDataModelsInput } from '../model';
import useFieldDataConfigurationUpdater from '../Hooks/useFieldDataConfigurationUpdater';
import AdditionalData from "../../../Components/AdditionalData";

type BooleanFieldProps = {
    id: string;
    selectedItem: TField | TSubmodel | TProductCategory | TConnector | null;
    userProjectDataModels: TUpsertISRProjectDataModelsInput;
    setUserProjectDataModels: React.Dispatch<React.SetStateAction<TUpsertISRProjectDataModelsInput>>;
    indexInfo: TIndexState;
    createISRProject:()=>void;
}

const BooleanField = ({id, selectedItem, userProjectDataModels, setUserProjectDataModels, indexInfo, createISRProject}: BooleanFieldProps) => {

    const { updateFieldConfiguration } = useFieldDataConfigurationUpdater({ setUserProjectDataModels });

    const updateFieldDataConfiguration = (updatedConfig: TFieldDataConfiguration) => {
        updateFieldConfiguration(indexInfo, updatedConfig, (selectedItem && 'belongsToDataModel' in selectedItem && selectedItem?.belongsToDataModel) ?? false);
    };

    return (
        <div id={id}>
            <FieldComponent 
                id={`${id}-field`}
                selectedItem={selectedItem} 
                userProjectDataModels={userProjectDataModels} 
                setUserProjectDataModels={setUserProjectDataModels} 
                indexInfo={indexInfo}
            />
            <br />
            <BooleanConfiguration 
                id={`${id}-boolean-config`}
                selectedItem={selectedItem} 
                updateFieldDataConfiguration={updateFieldDataConfiguration}
            />
            <br />
            <AdditionalData 
                id={`${id}-additional-data`}
                selectedItem={selectedItem} 
                userProjectDataModels={userProjectDataModels} 
                setUserProjectDataModels={setUserProjectDataModels} 
                indexInfo={indexInfo}
            />
            <br />
            <RulesComponent 
                id={`${id}-rules`}
                selectedItem={selectedItem} 
                userProjectDataModels={userProjectDataModels} 
                setUserProjectDataModels={setUserProjectDataModels} 
                indexInfo={indexInfo} 
                createISRProject={createISRProject} 
                featureType="Field"
            />
        </div>
    );
}

export default BooleanField;